const selector = 'meta[name=csrf-token]';
const attribute = 'content';

export const updateToken = (token) => {
  if (!token) {
    return;
  }

  const csrfElement = document.querySelector(selector);
  const currentToken = csrfElement.getAttribute(attribute);
  if (currentToken === token) {
    return;
  }

  csrfElement.setAttribute(attribute, token);
};
